import { type Component, type ComponentPublicInstance, createApp } from "vue";
import { getActivePinia } from "pinia"
import installAvv from "./_abstract/install-avv";
import { useDirectives } from "@component-library/directives";
import { trackVueError } from "./debug/errors";

/** This is a preferred way for creating vue application, it will automatically inject all needed libraries. */
export const createVueApp = (rootComponent: Component, rootProps?: Record<string, unknown> | null) => {
  const app = createApp(rootComponent, rootProps)

  // Add error signalling
  const existingErrorHandler = app.config.errorHandler

  app.config.errorHandler = (error: unknown, instance: ComponentPublicInstance | null, info: string) => {
    // Call original handler
    existingErrorHandler?.(error, instance, info)

    // Track error
    trackVueError(error, instance, info)
  }

  // Add support for pinia stores
  app.use(getActivePinia()!)

  // Used in _abstract components with A prefix - can be removed when these are no longers used.
  app.use({install: installAvv})

  // Directives
  useDirectives(app)

  return app
}
